import React from 'react';

/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
var index = {
  makePlugin: function makePlugin(_ref) {
    var path = _ref.path,
      auth = _ref.auth,
      SpoketreeAuthStore = _ref.SpoketreeAuthStore,
      solution = _ref.solution,
      SpoketreeSolutionStore = _ref.SpoketreeSolutionStore,
      options = _ref.options,
      PluginOptionsStore = _ref.PluginOptionsStore,
      pluginModelStores = _ref.pluginModelStores,
      PluginComponent = _ref.PluginComponent;
    return {
      path: path,
      options: options,
      PluginProvider: function PluginProvider(_ref2) {
        var children = _ref2.children;
        return /*#__PURE__*/React.createElement(NestedStoreProvider, {
          stores: pluginModelStores.public,
          index: 0
        }, /*#__PURE__*/React.createElement(SpoketreeAuthStore.Provider, {
          value: auth
        }, /*#__PURE__*/React.createElement(SpoketreeSolutionStore.Provider, {
          value: solution
        }, /*#__PURE__*/React.createElement(PluginOptionsStore.Provider, {
          value: options
        }, /*#__PURE__*/React.createElement(NestedStoreProvider, {
          stores: pluginModelStores.protected,
          index: 0
        }, children)))));
      },
      PluginComponent: PluginComponent
    };
  }
};
var NestedStoreProvider = function NestedStoreProvider(_ref3) {
  var children = _ref3.children,
    stores = _ref3.stores,
    index = _ref3.index;
  if (stores && index < stores.length) {
    var store = stores[index];
    return /*#__PURE__*/React.createElement(store.Provider, null, index === stores.length - 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement(NestedStoreProvider, {
      stores: stores,
      index: ++index
    }, children));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
};

export { index as default };
